import { handleAction } from 'redux-actions';
import { combineReducers } from 'redux';
import { propOr } from 'ramda';

import { SET_CLIENT_RETURN_URL } from 'app/features/checkout/actionTypes';
import { HOME_URL } from 'app/router/constants/externalUrls';

const clientReturnUrl = handleAction(
  SET_CLIENT_RETURN_URL,
  (state, action) => propOr(state, 'payload')(action),
  HOME_URL,
);

export { clientReturnUrl };

export default combineReducers({ clientReturnUrl });
